export default __webpack_public_path__ + "static/media/Warglory Chestguard.72f5b2bb.jpg";